import { useTranslation } from "react-i18next";

const CustomVideoRenderer = ({ mainState: { currentDocument } }) => {
  const { t } = useTranslation();
  if (!currentDocument) return null;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
      }}
    >
      <video controls style={{ width: "100%" }}>
        <source src={currentDocument.uri} type="video/mp4" />
        <source src={currentDocument.uri} type="video/quicktime" />
        {t("documentViewer.videoError")}
      </video>
    </div>
  );
};

CustomVideoRenderer.fileTypes = ["mp4", "mov"];
CustomVideoRenderer.weight = 1;

export default CustomVideoRenderer;
